import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 69108916-6CE9-456A-A1BE-9113F49B425E
 * name delete-empty-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/delete-empty-outline.svg
 * tags
 */
export const DeleteEmptyOutlineIcon = createSvgIcon(<><path d="M20.37,8.91L19.37,10.64L7.24,3.64L8.24,1.91L11.28,3.66L12.64,3.29L16.97,5.79L17.34,7.16L20.37,8.91M6,19V7H11.07L18,11V19A2,2 0 0,1 16,21H8A2,2 0 0,1 6,19M8,19H16V12.2L10.46,9H8V19Z" /></>, 'DeleteEmptyOutlineIcon');
export default DeleteEmptyOutlineIcon